// extracted by mini-css-extract-plugin
export default {"form__inner":"Input_form__inner__87WwD","form__inner__input":"Input_form__inner__input__JRCqa","invalid":"Input_invalid__2ab4Q","invalidInput":"Input_invalidInput__H1q34"};